import _styled from "styled-components";
import { useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { DocumentTextIcon, InformationCircleIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';
import { Button, Link } from '@restworld/ui-ds-base';
import { CoverLetterQuickGuide, TextArea, Title } from '../../../';
import TipsFromOurTeamModal from './tips-from-our-team-modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MAX_COVER_LETTER_LENGTH = 2000;
export var CoverLetterInputArea = function CoverLetterInputArea(_ref) {
  var onShowCoverLetterGuide = _ref.onShowCoverLetterGuide,
      onApplyWithCoverLetter = _ref.onApplyWithCoverLetter,
      loading = _ref.loading,
      coverLetter = _ref.coverLetter,
      setCoverLetterInput = _ref.setCoverLetterInput,
      isSpontaneousApplication = _ref.isSpontaneousApplication,
      _ref$showCoverLetterG = _ref.showCoverLetterGuide,
      showCoverLetterGuide = _ref$showCoverLetterG === void 0 ? true : _ref$showCoverLetterG,
      isError = _ref.isError;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      isTipsModalOpen = _useState[0],
      setIsTipsModalOpen = _useState[1];

  var submitButton = useMemo(function () {
    return /*#__PURE__*/_jsx(Button, {
      EndIcon: isSpontaneousApplication ? undefined : RocketLaunchIcon,
      onClick: onApplyWithCoverLetter,
      loading: loading,
      disabled: !coverLetter,
      fullwidth: true,
      children: t(isSpontaneousApplication ? 'onboarding-page:submit_spontaneous_application' : 'common:send_your_application')
    });
  }, [isSpontaneousApplication, onApplyWithCoverLetter, loading, coverLetter, t]);
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [showCoverLetterGuide ? /*#__PURE__*/_jsx(_StyledDiv2, {
      children: /*#__PURE__*/_jsx(CoverLetterQuickGuide, {
        showCloseButton: false
      })
    }) : null, /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv4, {
        children: [/*#__PURE__*/_jsxs(_StyledDiv5, {
          children: [/*#__PURE__*/_jsx(Title, {
            content: t('onboarding-page:write_the_cover_letter'),
            fontSize: showCoverLetterGuide ? 'superSuperLarge' : 'extraLarge',
            fontWeight: "semibold",
            twStyle: {
              "maxWidth": "24rem",
              "lineHeight": "1.688rem"
            }
          }), /*#__PURE__*/_jsx(Title, {
            content: t('onboarding-page:write_a_short_presentation'),
            fontSize: "base",
            fontWeight: "normal",
            twStyle: {
              "lineHeight": "1.5rem"
            },
            textColor: "gray"
          })]
        }), /*#__PURE__*/_jsxs(_StyledDiv6, {
          children: [/*#__PURE__*/_jsxs(_StyledDiv7, {
            children: [/*#__PURE__*/_jsxs(_StyledH, {
              children: [/*#__PURE__*/_jsx(_StyledSpan, {
                children: t('onboarding-page:why_are_you_applying')
              }), /*#__PURE__*/_jsx(_StyledSpan2, {
                children: "".concat((coverLetter === null || coverLetter === void 0 ? void 0 : coverLetter.length) || 0, " / ").concat(MAX_COVER_LETTER_LENGTH)
              })]
            }), /*#__PURE__*/_jsx(TextArea, {
              id: "cover letter",
              placeholder: t('onboarding-page:write_your_presentation'),
              rows: showCoverLetterGuide ? 13 : 8,
              maxLength: MAX_COVER_LETTER_LENGTH,
              onChange: function onChange(value) {
                return setCoverLetterInput(value);
              },
              value: coverLetter,
              twStyle: {
                "width": "100%",
                "minWidth": "100%",
                "--tw-border-opacity": "1",
                "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
                ":focus": {
                  "--tw-border-opacity": "1 !important",
                  "borderColor": "rgb(117 117 131 / var(--tw-border-opacity)) !important",
                  "--tw-ring-opacity": "1 !important",
                  "--tw-ring-color": "rgb(117 117 131 / var(--tw-ring-opacity)) !important"
                }
              },
              color: isError ? 'failure' : undefined,
              isError: isError,
              showMaxLength: false
            }), /*#__PURE__*/_jsx(_StyledDiv8, {
              children: /*#__PURE__*/_jsx(Link, {
                StartIcon: InformationCircleIcon,
                onClick: function onClick() {
                  return setIsTipsModalOpen(true);
                },
                newTab: false,
                children: t('onboarding-page:four_tips_from_our_team')
              })
            }), isError && /*#__PURE__*/_jsx(_StyledDiv9, {
              children: t('common:something_went_wrong')
            })]
          }), showCoverLetterGuide ? submitButton : null]
        })]
      }), !showCoverLetterGuide ? /*#__PURE__*/_jsxs(_StyledDiv10, {
        children: [!isSpontaneousApplication && /*#__PURE__*/_jsx(Button, {
          variant: "tertiary",
          StartIcon: DocumentTextIcon,
          fullwidth: true,
          onClick: onShowCoverLetterGuide,
          children: t('onboarding-page:open_the_guide')
        }), submitButton]
      }) : null]
    }), /*#__PURE__*/_jsx(TipsFromOurTeamModal, {
      isOpen: isTipsModalOpen,
      onClose: function onClose() {
        return setIsTipsModalOpen(false);
      }
    })]
  });
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv",
  componentId: "sc-7mbc53-0"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "gap": "1rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv2",
  componentId: "sc-7mbc53-1"
})({
  "maxWidth": "20rem",
  "borderRightWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
  "paddingRight": "2rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv3",
  componentId: "sc-7mbc53-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "8rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv4",
  componentId: "sc-7mbc53-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1rem",
  "textAlign": "center",
  "@media (min-width: 768px)": {
    "textAlign": "start"
  }
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv5",
  componentId: "sc-7mbc53-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "alignItems": "flex-start"
  }
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv6",
  componentId: "sc-7mbc53-5"
})({
  "display": "flex",
  "height": "100%",
  "maxHeight": "fit-content",
  "minHeight": "16.313rem",
  "width": "100%",
  "maxWidth": "32rem",
  "flexDirection": "column",
  "gap": "2.5rem",
  "borderRadius": "0.5rem",
  "padding": "1rem"
});

var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv7",
  componentId: "sc-7mbc53-6"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});

var _StyledH = /*#__PURE__*/_styled("h6").withConfig({
  displayName: "cover-letter-input-area___StyledH",
  componentId: "sc-7mbc53-7"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between"
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "cover-letter-input-area___StyledSpan",
  componentId: "sc-7mbc53-8"
})({
  "fontSize": "1rem !important",
  "lineHeight": "1.5rem !important",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var _StyledSpan2 = /*#__PURE__*/_styled("span").withConfig({
  displayName: "cover-letter-input-area___StyledSpan2",
  componentId: "sc-7mbc53-9"
})({
  "fontSize": "0.875rem !important",
  "lineHeight": "1.25rem !important",
  "--tw-text-opacity": "1",
  "color": "rgb(117 117 131 / var(--tw-text-opacity))"
});

var _StyledDiv8 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv8",
  componentId: "sc-7mbc53-10"
})({
  "display": "flex",
  "alignItems": "center"
});

var _StyledDiv9 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv9",
  componentId: "sc-7mbc53-11"
})({
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(204 0 34 / var(--tw-text-opacity))"
});

var _StyledDiv10 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "cover-letter-input-area___StyledDiv10",
  componentId: "sc-7mbc53-12"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});